module.exports = __webpack_public_path__ + "img/029-contract.e46f4033.svg";